(() => {
  /**
   * Used for products with image section.
   */

  if (customElements.get("products-slider")) {
    return;
  }

  class ProductsSlider extends HTMLElement {
    constructor() {
      super();
      this.desktopMatchQuery = window.matchMedia("(min-width: 990px)");
      this.isMobileOnly = this.hasAttribute("data-mobile-only");
      this.sliderElement = this.querySelector("[data-slider]");
      this.options = {
        spaceBetween: 16,
        slidesPerView: 1.2,
      };
    }

    initSlider() {
      if (!this.sliderElement) return;
      if (this.isMobileOnly && this.desktopMatchQuery.matches) {
        if (this.slider.destroyed) return;
        return this.destroy();
      }
      if (!!this.querySelector(".swiper-initialized")) return;
      this.slider = new Swiper(this.sliderElement, this.options);
    }

    destroy() {
      typeof this.slider.destroy === "function" &&
        this.slider.destroy(true, true);
    }

    connectedCallback() {
      this.initSlider();

      if (this.isMobileOnly) {
        window.addEventListener("resize", this.onResize.bind(this));
      }
    }

    onResize() {
      this.initSlider();
    }
  }

  customElements.define("products-slider", ProductsSlider);
})();
